import { useSelector } from "react-redux";

export function useHasPermission() {
  const {
    user: { info },
  } = useSelector((state) => state.profile);

  const roleName = info?.roles?.[0]?.name;
  const permissions = info?.permissions || [];

  /**
   * Checks if the user is authorized.
   * @param {string|string[]} allowedRoles - Role or array of roles allowed.
   * @param {string} permissionName - Specific permission name required for super-admin.
   * @param {string|string[]} exceptRoles - Role or array of roles to exclude/deny.
   * @returns {boolean} True if the user is authorized.
   */
  const hasPermission = (allowedRoles, permissionName, exceptRoles) => {
    if (!roleName) return false;

    if (roleName === "admin" || roleName === "super-admin") {
      if (permissionName) {
        return permissions.some((p) => p.name === permissionName);
      }
      return false;
    }

    const exceptArray = Array.isArray(exceptRoles)
      ? exceptRoles
      : exceptRoles
        ? [exceptRoles]
        : [];

    if (exceptArray.length > 0) {
      return !exceptArray.includes(roleName);
    }

    const rolesArray = Array.isArray(allowedRoles)
      ? allowedRoles
      : allowedRoles
        ? [allowedRoles]
        : [];

    return rolesArray.includes(roleName);
  };

  // const isTeamLeader = roleName === "user" && info?.has_team === true;
  const isTeamLeader = info?.has_team === true;
  const isAdmin = roleName === "admin" || roleName === "super-admin"

  return {
    hasPermission,
    roleName,
    permissions,
    info,
    isTeamLeader,
    isAdmin
  };
}

export default useHasPermission;
